import CommonDialog from '@src/new-components/Dialog/CommonDialog';
import CommonButton from '@src/new-components/Button';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { COLOR } from '@src/styles/color';
import UploadSubtitleFile from '@src/containers/Dubbing/UploadSubtitleFile';
import { countSubtitleCharacters } from '@src/utils/srt';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { PROJECT_PRODUCT } from '@src/constants/project';
import { trackProjectCreated } from '@src/services/moengage';
import { MOE_PROJECT_SOURCE_TYPE } from '@src/constants/moengage';
import route from '@src/constants/route';
import { CircularProgress } from '@mui/material';
import actions from '@src/redux/actions';

const UploadFileBySrt = ({ open, onClose, handleCreateProject }) => {
  const history = useHistory();
  const { sentences } = useSelector((state) => state.dubbingRequest);
  const uploadComponentRef = useRef(null);
  const [totalSeconds, setTotalSeconds] = useState(0);
  const [totalCharacters, setTotalCharacters] = useState(0);
  const [loadingCreateProject, setLoadingCreateProject] = useState(false);
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const dispatch = useDispatch();

  const handleChangeTotalSeconds = (seconds) => setTotalSeconds(seconds);
  const handleResetFile = () => uploadComponentRef.current?.click();

  useEffect(() => {
    const updatedTotalCharacters = countSubtitleCharacters(sentences);
    setTotalCharacters(updatedTotalCharacters);
  }, [Object.keys(sentences)]);

  const blocks = Object.keys(sentences).map((id) => {
    const sentenceData = sentences[id];
    return {
      id: uuidv4(),
      speed: 1,
      text: sentenceData.content || '',
      startTime: sentenceData.start,
      endTime: sentenceData.end,
    };
  });

  const handleCreateProjectSrt = async () => {
    setLoadingCreateProject(true);
    const data = {
      title: t('untitledTitleProject', {
        time: moment().format('YYYYMMDD-HH:mm'),
      }),
      product: PROJECT_PRODUCT.DUBBING,
      isDeleted: false,
      blocks,
      language,
    };
    const res = await handleCreateProject(data);
    if (res.status) {
      const idProject = res?.result?.project?.id;
      trackProjectCreated({
        product: PROJECT_PRODUCT.DUBBING,
        sourceType: MOE_PROJECT_SOURCE_TYPE.FILE_SRT,
      });
      history.push(`${route.PROJECTS}/${idProject}`);
      dispatch(actions.project.setProduct(PROJECT_PRODUCT.DUBBING));
    }
    setLoadingCreateProject(false);
  };

  return (
    <div>
      <CommonDialog
        open={open}
        title={t('uploadSubtitle')}
        width="640px"
        styleContent={{
          padding: '24px',
        }}
        onClose={onClose}
        contentComponent={
          <UploadSubtitleFile
            resetRef={uploadComponentRef}
            totalCharacters={totalCharacters}
            totalSeconds={totalSeconds}
            onChangeTotalSeconds={handleChangeTotalSeconds}
            onResetFile={handleResetFile}
          />
        }
        actionComponent={
          <>
            <CommonButton
              variant="outlineSmall"
              textProps={{
                variantText: 'body-14-semibold',
                color: COLOR.darkBlue,
              }}
              customStyle={{
                height: '40px',
                padding: '8px 24px',
                borderRadius: '8px',
              }}
              onClick={onClose}
            >
              {t('cancel')}
            </CommonButton>
            <CommonButton
              variant="contained"
              textProps={{
                variantText: 'body-14-semibold',
                color: COLOR.darkBlue,
              }}
              customStyle={{
                height: '40px',
                padding: '8px 24px',
                borderRadius: '8px',
                width: '105px',
              }}
              disabled={
                Object.keys(sentences).length === 0 || loadingCreateProject
              }
              onClick={handleCreateProjectSrt}
            >
              {loadingCreateProject ? (
                <CircularProgress size={16} sx={{ color: COLOR.darkBlue }} />
              ) : (
                t('next')
              )}
            </CommonButton>
          </>
        }
      />
    </div>
  );
};

export default UploadFileBySrt;
